<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { team_based_conversation_visibility: teamVisibility } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!teamVisibility;
  },
  { deep: true, immediate: true }
);

const toggleTeamConversationVisibility = async () => {
  try {
    await updateAccount(
      { team_based_conversation_visibility: isEnabled.value },
      { silent: true }
    );
    useAlert(
      t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_VISIBILITY.API.SUCCESS')
    );
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_VISIBILITY.API.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_VISIBILITY.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_VISIBILITY.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch
          v-model="isEnabled"
          :aria-label="
            t('GENERAL_SETTINGS.FORM.TEAM_CONVERSATION_VISIBILITY.TITLE')
          "
          @change="toggleTeamConversationVisibility"
        />
      </div>
    </template>
  </SectionLayout>
</template>
